import React from "react";
import BuildingForm from "./BuildingForm";

export default function EditBuilding(){

    return(
        <BuildingForm type="Edit" />
    )
}
